module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [(_vm.quizObj && _vm.quizObj.quiz) ? _c('div', {
    staticClass: "row",
    class: {
      'mt-30': _vm.quizSlug
    }
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.quizSlug),
      expression: "!quizSlug"
    }],
    staticClass: "col-xs-12 mb-10"
  }, [_c('h1', [_vm._v(_vm._s(_vm.quizObj.quiz.title))])]), _vm._v(" "), _c('div', {
    class: {
      'col-lg-2 col-md-3 col-sm-5 col-xs-5': !_vm.quizSlug, 'col-xs-4': _vm.quizSlug
    }
  }, [_c('div', {
    staticClass: "col-xs-12 p-0"
  }, [_c('span', {
    staticClass: "dashboard-stat dashboard-stat-v2 green nb_participants"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "details"
  }, [(_vm.quizObj.quiz && _vm.quizObj.quiz.responses) ? _c('div', {
    staticClass: "number"
  }, [_c('span', {
    attrs: {
      "data-counter": "counterup",
      "data-value": _vm.quizObj.nbResponses()
    }
  }, [_vm._v(_vm._s(_vm.quizObj.nbResponses()))])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "desc"
  }, [_vm._v(" Réponses ")])])])]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-12 p-0 mt-10"
  }, [_c('span', {
    staticClass: "dashboard-stat dashboard-stat-v2 yellow nb_participants"
  }, [_vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "details"
  }, [(!Number.isNaN(_vm.nbParticipants)) ? _c('div', {
    staticClass: "number"
  }, [_c('span', {
    attrs: {
      "data-counter": "counterup",
      "data-value": _vm.nbParticipants
    }
  }), _vm._v(_vm._s(_vm.nbParticipants) + "\n                  ")]) : _c('div', {
    staticClass: "number"
  }, [_c('img', {
    staticStyle: {
      "width": "40px"
    },
    attrs: {
      "src": "/static/img/infinite.svg",
      "alt": "symbole infini"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "desc"
  }, [_vm._v(" Participants")])])])])]), _vm._v(" "), _c('div', {
    class: {
      'col-lg-4 col-md-9 col-sm-12 col-xs-12': !_vm.quizSlug, 'col-xs-8': _vm.quizSlug
    }
  }, [_c('div', {
    staticClass: "widget-thumb widget-bg-color-white margin-bottom-20 bordered bg-gray bloc_filter"
  }, [_c('h4', {
    staticClass: "widget-thumb-heading text-uppercase "
  }, [_vm._v("Statistique par groupe")]), _vm._v(" "), _c('div', {
    staticClass: "widget-thumb-wrap"
  }, [_c('div', {
    staticClass: "graph_stat_group",
    attrs: {
      "id": 'chartdiv' + _vm.number
    }
  })])])]), _vm._v(" "), _c('div', {
    class: {
      'col-lg-3': !_vm.quizSlug, 'col-xs-6': _vm.quizSlug
    }
  }, [_c('div', {
    staticClass: "widget-thumb widget-bg-color-white margin-bottom-20 bordered bg-gray bloc_filter"
  }, [_c('h4', {
    staticClass: "widget-thumb-heading text-uppercase"
  }, [_vm._v("Filtre")]), _vm._v(" "), _c('div', {
    staticClass: "widget-thumb-wrap"
  }, [_c('div', {
    staticClass: "mt-checkbox-list"
  }, _vm._l((_vm.quizObj.quiz.groups), function(group) {
    return _c('label', {
      staticClass: "mt-checkbox"
    }, [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.quizObj.filters),
        expression: "quizObj.filters"
      }],
      attrs: {
        "type": "checkbox"
      },
      domProps: {
        "value": group,
        "checked": Array.isArray(_vm.quizObj.filters) ? _vm._i(_vm.quizObj.filters, group) > -1 : (_vm.quizObj.filters)
      },
      on: {
        "change": function($event) {
          _vm.refresh()
        },
        "__c": function($event) {
          var $$a = _vm.quizObj.filters,
            $$el = $event.target,
            $$c = $$el.checked ? (true) : (false);
          if (Array.isArray($$a)) {
            var $$v = group,
              $$i = _vm._i($$a, $$v);
            if ($$c) {
              $$i < 0 && (_vm.quizObj.filters = $$a.concat($$v))
            } else {
              $$i > -1 && (_vm.quizObj.filters = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
            }
          } else {
            _vm.quizObj.filters = $$c
          }
        }
      }
    }), _vm._v(" " + _vm._s(group.name) + "\n                      "), _c('span')])
  }))])])]), _vm._v(" "), _c('div', {
    class: {
      'col-lg-3': !_vm.quizSlug, 'col-xs-6': _vm.quizSlug
    }
  }, [_c('div', {
    staticClass: "widget-thumb widget-bg-color-white margin-bottom-20 bordered bg-gray bloc_actions"
  }, [_c('h4', {
    staticClass: "widget-thumb-heading  text-uppercase"
  }, [_vm._v("Actions")]), _vm._v(" "), _c('div', {
    staticClass: "row p-0"
  }, [_c('div', {
    staticClass: "col-md-12 col-sm-6 col-xs-6 mb-10"
  }, [_c('router-link', {
    staticClass: "btn btn-circle white",
    attrs: {
      "to": {
        name: 'quizzes_edit',
        params: {
          slug: _vm.quizObj.quiz.slug
        }
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-share"
  }), _vm._v("\n                Partager le formulaire\n              ")])], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-12 col-sm-6 col-xs-6 mb-10"
  }, [_c('router-link', {
    staticClass: "btn btn-circle green",
    attrs: {
      "to": {
        name: 'quizzes_preconizations',
        params: {
          slug: _vm.quizObj.quiz.slug
        }
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-gear"
  }), _vm._v("\n                Préconisations et analyses\n              ")])], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-12 col-sm-6 col-xs-6 mb-10"
  }, [_c('a', {
    staticClass: "btn btn-circle yellow",
    attrs: {
      "href": _vm.file_responses.href,
      "download": _vm.file_responses.name,
      "title": "Télécharger les questions ouvertes"
    }
  }, [_c('i', {
    staticClass: "fa fa-download fs-20",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" Télécharger QO\n              ")])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-12 col-sm-6 col-xs-6 mb-10"
  }, [_c('a', {
    staticClass: "btn btn-circle yellow",
    attrs: {
      "href": _vm.file_participants.href,
      "download": _vm.file_participants.name,
      "title": "Télécharger la liste des participants"
    }
  }, [_c('i', {
    staticClass: "fa fa-download fs-20",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" Télécharger liste des participants\n              ")])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-12 col-sm-6 col-xs-6"
  }, [_c('router-link', {
    staticClass: "btn btn-circle yellow",
    attrs: {
      "to": {
        name: 'quizzes_export_pdf',
        params: {
          slug: _vm.quizObj.quiz.slug
        }
      },
      "title": "Rapport PDF"
    }
  }, [_c('i', {
    staticClass: "fa fa-print fs-20",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" Export PDF ")])], 1)])])])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [(_vm.quizObj && _vm.quizObj.quiz) ? _c('div', {
    staticClass: "col-lg-12"
  }, [_c('div', {
    staticClass: "portlet light portlet-fit portlet-form bordered col-xs-12 p-0 ",
    attrs: {
      "id": "testExportPdf"
    }
  }, [_c('div', {
    staticClass: "portlet-title col-xs-12 "
  }, [_c('div', {
    staticClass: "caption tabbable-line p-0"
  }, [_c('ul', {
    staticClass: "nav nav-tabs "
  }, [_c('li', {
    staticClass: "active"
  }, [_c('a', {
    attrs: {
      "data-toggle": "tab",
      "aria-expanded": "true"
    },
    on: {
      "click": function($event) {
        _vm.show.graph = true
      }
    }
  }, [_c('i', {
    staticClass: " icon-pie-chart"
  }), _vm._v(" "), _c('span', {
    staticClass: "caption-subject sbold uppercase"
  }, [_vm._v("Synthèse")])])]), _vm._v(" "), _c('li', {}, [_c('a', {
    attrs: {
      "data-toggle": "tab",
      "aria-expanded": "false"
    },
    on: {
      "click": function($event) {
        _vm.show.tab = true
      }
    }
  }, [_c('i', {
    staticClass: " icon-list"
  }), _vm._v(" "), _c('span', {
    staticClass: "caption-subject sbold uppercase"
  }, [_vm._v("Tableau QO")])])]), _vm._v(" "), _c('li', {}, [_c('a', {
    attrs: {
      "data-toggle": "tab",
      "aria-expanded": "false"
    },
    on: {
      "click": function($event) {
        _vm.show.participants = true
      }
    }
  }, [_c('i', {
    staticClass: " icon-users"
  }), _vm._v(" "), _c('span', {
    staticClass: "caption-subject sbold uppercase"
  }, [_vm._v("Participants ")])])])])])]), _vm._v(" "), (_vm.quizObj.quiz.questions) ? _c('div', {
    staticClass: "portlet-body col-xs-12 mb-30"
  }, [(_vm.show.graph && _vm.quizObj.quiz.responses.length > 0 && _vm.nbQuestionsOpenOutMultiple < _vm.quizObj.quiz.questions.length) ? _c('div', {
    staticClass: "col-xs-12 text-right mt-10"
  }, [_c('a', {
    staticClass: "btn btn-xs default",
    on: {
      "click": function($event) {
        _vm.changeAllGraphType('simple');
      }
    }
  }, [_vm._v("Graphiques simples")]), _vm._v(" "), _c('a', {
    staticClass: "btn btn-xs default",
    on: {
      "click": function($event) {
        _vm.changeAllGraphType('détaillé');
      }
    }
  }, [_vm._v("Graphiques détaillés")]), _vm._v(" "), _c('a', {
    staticClass: "btn btn-xs default",
    on: {
      "click": function($event) {
        _vm.changeAllLegendesType('below');
      }
    }
  }, [_vm._v("Légendes en dessous")]), _vm._v(" "), _c('a', {
    staticClass: "btn btn-xs default",
    on: {
      "click": function($event) {
        _vm.changeAllLegendesType('above');
      }
    }
  }, [_vm._v("Légendes superposées")])]) : _vm._e(), _vm._v(" "), _vm._l((_vm.quizObj.quiz.questions), function(question, index) {
    return _c('div', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (_vm.show.graph),
        expression: "show.graph"
      }]
    }, [(question.type != 'text') ? _c('div', [_c('div', {
      staticClass: "mt-element-ribbon col-xs-12 p-0"
    }, [_c('div', {
      staticClass: "ribbon ribbon-border-hor ribbon-clip ribbon-color-info uppercase"
    }, [_c('div', {
      staticClass: "ribbon-sub ribbon-clip"
    }), _vm._v(" Question n°" + _vm._s(index + 1) + "\n                    ")])]), _vm._v(" "), _c('div', {
      staticClass: "col-xs-12 p-0 ml-10",
      staticStyle: {
        "margin-top": "-20px"
      }
    }, [_c('a', {
      staticClass: "btn btn-xs default",
      on: {
        "click": function($event) {
          _vm.changeGraphType(question);
        }
      }
    }, [_vm._v("Graphique " + _vm._s(question.graphType) + " "), (!question.graphType) ? _c('span', [_vm._v("détaillé")]) : _vm._e()]), _vm._v(" "), _c('a', {
      staticClass: "btn btn-xs default",
      on: {
        "click": function($event) {
          _vm.changeLegendeType(question);
        }
      }
    }, [_vm._v("Légende "), (!question.legendeType || question.legendeType == 'below') ? _c('span', [_vm._v("superposée")]) : _c('span', [_vm._v("en dessous")])])]), _vm._v(" "), _c('div', {
      staticClass: "col-xs-12 p-0 text-center"
    }, [_c('h3', [_vm._v(_vm._s(question.title))]), _vm._v(" "), _c('div', {
      staticClass: "graph",
      staticStyle: {
        "margin-top": "30px"
      },
      attrs: {
        "id": 'container' + question.id + '-' + _vm.number
      }
    }, [_vm._v("Aucune réponse")])]), _vm._v(" "), _vm._l((question.data), function(data) {
      return (data.question && data.question.title && data.question.type != 'text') ? _c('div', {
        staticClass: "col-xs-12 p-0 text-center mt-30"
      }, [_c('h4', [_vm._v(_vm._s(data.name) + " - " + _vm._s(data.question.title))]), _vm._v(" "), _c('div', {
        staticClass: "text-left ml-10"
      }, [_c('a', {
        staticClass: "btn btn-xs default",
        on: {
          "click": function($event) {
            _vm.changeGraphType(data.question, question);
          }
        }
      }, [_vm._v("Graphique " + _vm._s(data.question.graphType) + " "), (!data.question.graphType) ? _c('span', [_vm._v("détaillé")]) : _vm._e()]), _vm._v(" "), _c('a', {
        staticClass: "btn btn-xs default",
        on: {
          "click": function($event) {
            _vm.changeLegendeType(data.question, question);
          }
        }
      }, [_vm._v("Légende "), (!data.question.legendeType || data.question.legendeType == 'below') ? _c('span', [_vm._v("superposée")]) : _c('span', [_vm._v("en dessous")])])]), _vm._v(" "), _c('div', {
        staticClass: "graph",
        staticStyle: {
          "margin-top": "30px"
        },
        attrs: {
          "id": 'container_child' + data.id + '-' + _vm.number
        }
      }, [_vm._v("Aucune réponse")])]) : _vm._e()
    })], 2) : _vm._e()])
  }), _vm._v(" "), (_vm.show.graph && _vm.nbQuestionsOpenOutMultiple >= _vm.quizObj.quiz.questions.length) ? _c('div', {
    staticClass: "col-xs-12 m-30"
  }, [_vm._v("\n                Ce questionnaire ne contient que des questions ouvertes !\n              ")]) : _vm._e(), _vm._v(" "), (_vm.show.graph && _vm.quizObj.quiz.responses.length > 0 && _vm.nbQuestionsOpenOutMultiple < _vm.quizObj.quiz.questions.length) ? _c('div', {
    staticClass: "col-xs-12 text-right"
  }, [_c('a', {
    staticClass: "btn btn-xs default",
    on: {
      "click": function($event) {
        _vm.changeAllGraphType('simple');
      }
    }
  }, [_vm._v("Graphiques simples")]), _vm._v(" "), _c('a', {
    staticClass: "btn btn-xs default",
    on: {
      "click": function($event) {
        _vm.changeAllGraphType('détaillé');
      }
    }
  }, [_vm._v("Graphiques détaillés")]), _vm._v(" "), _c('a', {
    staticClass: "btn btn-xs default",
    on: {
      "click": function($event) {
        _vm.changeAllLegendesType('below');
      }
    }
  }, [_vm._v("Légendes en dessous")]), _vm._v(" "), _c('a', {
    staticClass: "btn btn-xs default",
    on: {
      "click": function($event) {
        _vm.changeAllLegendesType('above');
      }
    }
  }, [_vm._v("Légendes superposées")])]) : _vm._e(), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.show.tab),
      expression: "show.tab"
    }]
  }, [(_vm.nbQuestionsOpen > 0) ? _c('div', {
    staticClass: "col-xs-12"
  }, [_c('list', {
    attrs: {
      "columns": _vm.columns,
      "dataSet": _vm.dataSet,
      "id": 'qo' + _vm.number
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.nbQuestionsOpen <= 0) ? _c('div', {
    staticClass: "col-xs-12"
  }, [_vm._v("\n                    Ce questionnaire ne contient pas de questions ouvertes !\n                ")]) : _vm._e()]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.show.participants),
      expression: "show.participants"
    }]
  }, [(_vm.quizObj.quiz.responses.length > 0) ? _c('div', {
    staticClass: "col-xs-12"
  }, [_c('list', {
    attrs: {
      "columns": _vm.columnsParticipants,
      "dataSet": _vm.dataSetParticipants,
      "id": 'participants' + _vm.number
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.quizObj.quiz.responses.length <= 0) ? _c('div', {
    staticClass: "col-xs-12"
  }, [_vm._v("\n                    Ce questionnaire ne contient aucune réponse.\n                ")]) : _vm._e()])], 2) : _vm._e(), _vm._v(" "), (!_vm.quizObj.quiz.questions || (_vm.quizObj.quiz.questions && _vm.quizObj.quiz.questions.length <= 0)) ? _c('div', {
    staticClass: "col-xs-12 p-0 text-center"
  }, [_c('h3', [_vm._v("Aucune questions à ce questionnaire !")])]) : _vm._e()])]) : _c('div', {
    staticClass: "row m-0"
  }, [_c('div', {
    staticClass: "col-md-12 page-404 mt-50"
  }, [_c('div', {
    staticClass: "number font-green"
  }, [_vm._v(" 404 ")]), _vm._v(" "), _c('div', {
    staticClass: "details"
  }, [_c('h3', [_vm._v("Oops ! Questionnaire non trouvé.")]), _vm._v(" "), _c('p', [_vm._v(" Nous n'avons pas réussi à trouver ce questionnaire.\n                  "), _c('br'), _vm._v("\n                  Vérifiez l'url et tentez de recharger la page.\n              ")])])])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "visual"
  }, [_c('i', {
    staticClass: "fa fa-bar-chart-o"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "visual"
  }, [_c('i', {
    staticClass: "fa fa-group"
  })])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-15fa43ac"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/quizzes/responses.vue
// module id = 103
// module chunks = 0